import React from 'react';
import styles from './InviteContainer.scss';
import { useTranslation } from 'react-i18next';

const TestDetails = ({ title, numProblems, time }) => {
  const { t } = useTranslation('common');

  return (
    <div className={styles['c-invite__test-details']}>
      <h1 className="header-font-size font-weight-bold">{title}</h1>
      <p className="sub-header-font-size-mid">
        {t('test_details.summary', {
          count: numProblems,
          time,
        })}
      </p>
    </div>
  );
};

export default TestDetails;
